import { initializeApp } from '@firebase/app'
import {
  getMessaging,
  getToken,
  NotificationPayload,
  onMessage,
} from 'firebase/messaging'
import { userNotification } from '../../app/modules/auth/core/_requests'

const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_FIREBASE_VAPID_KEY,
} = process.env

const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: REACT_APP_FIREBASE_APP_ID,
  measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      console.log('Notification permission granted.')
      const token = await getToken(messaging, {
        vapidKey: REACT_APP_FIREBASE_VAPID_KEY,
      })

      await userNotification(token)

      console.log('Firebase Token Successfully fetched.')
      return token
    } else {
      console.log('Notification permission denied.')
    }
  } catch (error) {
    console.log('firebase error', error)
  }
}

export const onForegroundMessage = (callBack: () => void) => {
  try {
    return onMessage(messaging, (payload) => {
      console.log('Message received on Foreground:', payload)
      callBack()

      playNotificationSound()
      // Check notification permission first
      if (Notification.permission === 'granted') {
        const { title, body } = payload.notification as NotificationPayload
        new Notification(title ?? '', { body })
      } else {
        console.warn('Notification permission not granted')
      }

      if (payload.data?.route && payload.data?.id) {
        // Handle custom data if needed
      }
    })
  } catch (error) {
    console.error('Error in onMessage:', error)
    return () => {}
  }
}

export const registerNotificationServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(() => {
        console.log('Service Worker registration successful.')
        return navigator.serviceWorker.ready
      })
      .then(() => {
        console.log('Service Worker is ready.')
        requestNotificationPermission()
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error)
      })
  } else {
    console.error('Service workers are not supported in this browser.')
  }
}

function playNotificationSound() {
  const soundPath = '/media/sound/notification-sound.wav'
  const audio = new Audio(soundPath)
  audio.play().catch((e) => console.log('Audio play failed:', e))
}
